// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    updateRegistration,
    updateRegistrationPin,
    updateUseAmount
} from './registration';
import actions from '../../actions-list';
import {findMatchingKey} from '../../../claim/shared/services/claim-shared-helper';
import {getDetails} from '../../shared/repositories';
import {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import {readFilteredEndUseCodes} from './filtered-end-use-codes';
import {readFilteredPurchaserType} from './filtered-purchaser-type';
import {readLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import {updateFormValidation} from './form-validation';

export const resetProductDetails = () =>

    dispatch =>

        dispatch({
            data: getProductDefaultState(),
            type: actions.UPDATE_PRODUCT_REGISTRATION_PRODUCT
        });

/* eslint-disable complexity, max-params */

export const readProductDetails = (pin, shouldUpdateRegistrationStatus, registrationTypes, statusIndicator, customer) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pin);

            dispatch({
                data,
                type: actions.UPDATE_PRODUCT_REGISTRATION_PRODUCT
            });

            updateRegistrationPin(data.pin)(dispatch);

            if (customer && customer.type[0]) {

                const filter1 = {filter1Key: 'INDUSTRY_INDICATOR', filter1Operator: 'eq', filter1Value: data.industryIndicator};
                const filter2 = {filter2Key: 'DEALER_ID', filter2Operator: 'eq', filter2Value: data.dealer.account};
                const filter3 = {filter3Key: 'CUST_TYPE', filter3Operator: 'eq', filter3Value: customer.type[0]};

                readFilteredEndUseCodes(filter1, filter2, filter3)(dispatch);
                readFilteredPurchaserType('CUST_TYPE', 'eq', customer.type[0])(dispatch);

            }

            if (shouldUpdateRegistrationStatus) {

                const statusIndicatorKey = data.customerSummary.id ? 'USED' : 'NEW';
                const statusIndicatorType = findMatchingKey(statusIndicatorKey, registrationTypes);

                updateRegistration('statusIndicator', statusIndicatorType)(dispatch);

            }

            if (statusIndicator && statusIndicator === 'NEW' && data.customerSummary.id) {

                updateFormValidation('registrationStatus', '')(dispatch);

            }

            if (data.useAmountAllowedUnits.length === 1) {

                const useAmountUnit = findMatchingKey(data.useAmountAllowedUnits[0].key, data.useAmountAllowedUnits);

                updateUseAmount('unit', useAmountUnit)(dispatch);

            }

            if (data.otherUnitRequired === 'N') {

                readLatestPerUnitMeasurements(data.pin)(dispatch);

            }

        } catch (error) {

            resetProductDetails()(dispatch);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/product-details.js